// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{width:100%;height:100%;background-color:#5f6e8e}", ""]);
// Exports
module.exports = exports;
